(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[801],{

/***/ 50361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseClone = __webpack_require__(85990);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),

/***/ 73042:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sign-up",
      function () {
        return __webpack_require__(79499);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 79499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sign_up; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(58408);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(56580);
// EXTERNAL MODULE: ../../node_modules/redux/es/redux.js + 1 modules
var redux = __webpack_require__(38726);
// EXTERNAL MODULE: ./src/analytics/events/index.ts + 4 modules
var events = __webpack_require__(45003);
// EXTERNAL MODULE: ./src/analytics/events/constants.ts
var constants = __webpack_require__(45048);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
// EXTERNAL MODULE: ./src/constants/styles.ts
var styles = __webpack_require__(30438);
;// CONCATENATED MODULE: ./src/components/app/authForms/emailVerification/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0 0 ",
        "px;\n\n  h2 {\n    margin-top: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var StyledEmailVerificationContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-518e7e7-0"
})(_templateObject(), styles/* LAYOUT.GUTTER */._.GUTTER * 2);

// EXTERNAL MODULE: ./src/components/cmsConfig/stringAccessor/index.tsx
var stringAccessor = __webpack_require__(90836);
// EXTERNAL MODULE: ./src/constants/routes.ts
var routes = __webpack_require__(25643);
;// CONCATENATED MODULE: ./src/components/app/authForms/emailVerification/index.tsx







var EmailVerification = function(props) {
    var referrer = props.referrer;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledEmailVerificationContent, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        tag: "h1",
                        accessor: "signup.email_verification_header"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        tag: "p",
                        accessor: "signup.email_verification_text",
                        html: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "".concat(routes/* ROUTES.LOGIN */.Z6.LOGIN, "?referrer=").concat(referrer),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    onClick: function() {
                        return (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.AUTH__CLICK_SIGN_IN */.x.AUTH__CLICK_SIGN_IN);
                    },
                    children: "Return to Login"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/app/authForms/layout/styles.tsx
var layout_styles = __webpack_require__(61098);
// EXTERNAL MODULE: ./src/components/app/authForms/signUpForm/index.tsx + 1 modules
var signUpForm = __webpack_require__(49932);
// EXTERNAL MODULE: ./src/components/app/layout/index.tsx + 110 modules
var layout = __webpack_require__(37356);
// EXTERNAL MODULE: ./src/components/uielements/hr/index.ts
var hr = __webpack_require__(51912);
// EXTERNAL MODULE: ./src/redux/auth/actions.ts
var actions = __webpack_require__(45479);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(36304);
// EXTERNAL MODULE: ./src/utils/stringHelpers.ts
var stringHelpers = __webpack_require__(60738);
;// CONCATENATED MODULE: ./pages/sign-up.tsx























var SignUp = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(SignUp, Component);
    var _super = (0,_create_super/* default */.Z)(SignUp);
    function SignUp() {
        (0,_class_call_check/* default */.Z)(this, SignUp);
        return _super.apply(this, arguments);
    }
    var _proto = SignUp.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _props = this.props, emailVerificationToggle = _props.emailVerificationToggle, toggleEmailVerification = _props.toggleEmailVerification;
        emailVerificationToggle && toggleEmailVerification(false);
    };
    _proto.render = function render() {
        var _props = this.props, router = _props.router, webConfig = _props.webConfig, emailVerificationToggle = _props.emailVerificationToggle, loading = _props.loading;
        var loginReferrer = (0,global/* deriveReferrer */.k5)(router);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* default */.Z, {
            backgroundOverride: true,
            disabled: (0,stringHelpers/* safelyGetConfig */.K6)(webConfig, "accounts.disable_accounts"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_styles/* StyledAuthPageLayout */.e, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_styles/* StyledAuthPageContent */.x, {
                    children: !loading && emailVerificationToggle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EmailVerification, {
                        referrer: loginReferrer
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                tag: "h1",
                                accessor: "signup.header",
                                html: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                tag: "h3",
                                accessor: "signup.subheader",
                                html: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(hr/* StyledHr */.n, {
                                background: "transparent"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(signUpForm/* SignUpFormContainer */.e, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(hr/* StyledHr */.n, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                        accessor: "login.prompt",
                                        html: true
                                    }),
                                    "\xa0",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "".concat(routes/* ROUTES.LOGIN */.Z6.LOGIN, "?referrer=").concat(loginReferrer),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: function() {
                                                return (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.AUTH__CLICK_SIGN_IN */.x.AUTH__CLICK_SIGN_IN);
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                                accessor: "login.cta"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        });
    };
    SignUp.getInitialProps = function getInitialProps() {
        return (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2,
                    {}
                ];
            });
        })();
    };
    return SignUp;
}(react.Component);
var mapStateToProps = function(state) {
    return {
        emailVerificationToggle: state.app.auth.emailVerificationToggle,
        loading: state.app.auth.loading,
        webConfig: state.app.cmsConfig.webConfig
    };
};
var mapDispatchToProps = {
    toggleEmailVerification: actions/* default.toggleEmailVerification */.Z.toggleEmailVerification
};
var connector = (0,es.connect)(mapStateToProps, mapDispatchToProps);
/* harmony default export */ var sign_up = ((0,redux/* compose */.qC)(connector, router.withRouter)(SignUp));


/***/ }),

/***/ 61098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ StyledAuthPageLayout; },
/* harmony export */   "x": function() { return /* binding */ StyledAuthPageContent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89961);
/* harmony import */ var _constants_styles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30438);
/* harmony import */ var _redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73393);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: calc(100vh - ",
        "px);\n\n  @media (max-width: 767px) {\n    background-color: ",
        ";\n    min-height: calc(100vh - ",
        "px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledAuthPageLayout = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-44565f4c-0"
})(_templateObject(), _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.HEADERHEIGHT */ ._.HEADERHEIGHT * 2, function(param) {
    var theme = param.theme;
    return theme.auth_page.background_color;
}, _constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.MOBILE_HEADERHEIGHT */ ._.MOBILE_HEADERHEIGHT * 2);
var _background_color, _border_color, _border_radius, _background_color1;
var StyledAuthPageContent = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-44565f4c-1"
})(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        backgroundColor: (_background_color = theme.auth_page.background_color) !== null && _background_color !== void 0 ? _background_color : "transparent",
        border: "1px solid ".concat((_border_color = theme.auth_page.border_color) !== null && _border_color !== void 0 ? _border_color : "transparent"),
        borderRadius: "".concat((_border_radius = theme.auth_page.border_radius) !== null && _border_radius !== void 0 ? _border_radius : 0, "px"),
        margin: "0 auto",
        maxWidth: "".concat(_constants_styles__WEBPACK_IMPORTED_MODULE_1__/* .LAYOUT.MEDIUM_CONTENT */ ._.MEDIUM_CONTENT, "px"),
        padding: "40px 20px",
        textAlign: "center",
        width: "100%"
    }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFontStyles */ .l)(theme.auth_page.font)), {
        h1: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            margin: 0
        }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFontStyles */ .l)(theme.auth_page.secondary_font)),
        h3: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFontStyles */ .l)(theme.auth_page.font, [
            "color",
            "font_family",
            "font_size",
            "font_style",
            "line_height", 
        ])), {
            fontWeight: "normal",
            margin: 0
        }),
        p: {
            margin: "20px 0 0"
        },
        a: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            textDecoration: "underline",
            transition: "opacity 0.2s linear"
        }, (0,_redux_cmsConfig_utils__WEBPACK_IMPORTED_MODULE_5__/* .getFontStyles */ .l)(theme.auth_page.tertiary_font)), {
            "&:hover": {
                opacity: 0.7
            }
        }),
        "@media (max-width: 767px)": {
            borderColor: (_background_color1 = theme.auth_page.background_color) !== null && _background_color1 !== void 0 ? _background_color1 : "transparent"
        }
    });
});


/***/ }),

/***/ 3176:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm; }
});

// UNUSED EXPORTS: ReCAPTCHA

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ../../node_modules/react-google-recaptcha/lib/esm/recaptcha.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return react.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(react.Component);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: (prop_types_default()).string.isRequired,
  onChange: (prop_types_default()).func,
  grecaptcha: (prop_types_default()).object,
  theme: prop_types_default().oneOf(["dark", "light"]),
  type: prop_types_default().oneOf(["image", "audio"]),
  tabindex: (prop_types_default()).number,
  onExpired: (prop_types_default()).func,
  onErrored: (prop_types_default()).func,
  size: prop_types_default().oneOf(["compact", "normal", "invisible"]),
  stoken: (prop_types_default()).string,
  hl: (prop_types_default()).string,
  badge: prop_types_default().oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
// EXTERNAL MODULE: ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(73463);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ../../node_modules/react-async-script/lib/esm/async-script-loader.js
function async_script_loader_extends() { async_script_loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return async_script_loader_extends.apply(this, arguments); }

function async_script_loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function async_script_loader_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      async_script_loader_inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = async_script_loader_objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return (0,react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(react.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0,react.forwardRef)(function (props, ref) {
      return (0,react.createElement)(AsyncScriptLoader, async_script_loader_extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: (prop_types_default()).func
    };
    return hoist_non_react_statics_cjs_default()(ForwardedComponent, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ../../node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js


var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

/* harmony default export */ var recaptcha_wrapper = (makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA));
;// CONCATENATED MODULE: ../../node_modules/react-google-recaptcha/lib/esm/index.js


/* harmony default export */ var esm = (recaptcha_wrapper);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [513,372,295,593,588,356,567,774,888,179], function() { return __webpack_exec__(73042); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);